import React, { useContext, useEffect } from 'react';
import { ApplicationContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { useIsMobileResolution } from '../../../hooks/use-is-mobile-resolution.js';
import { useIsXSmallResolution } from '../../../hooks/use-is-xsmall-resolution.js';
import { ContextualBar } from '../../heading/contextual-bar/contextual-bar.js';
import { Modal } from '../../modal/modal.js';
function FilterModal(props) {
    const applicationContext = useContext(ApplicationContext.Context);
    const isXSmallResolution = useIsXSmallResolution();
    const isMobileResolution = useIsMobileResolution();
    useEffect(() => {
        if (!isMobileResolution) {
            return;
        }
        const popItem = applicationContext.pushNavigationItem(props.onClose);
        return () => popItem();
    }, [isMobileResolution]);
    const closeable = !isXSmallResolution;
    const modalTitle = isXSmallResolution ? '' : props.title;
    const contextualBarTitle = isXSmallResolution ? props.title : '';
    return (React.createElement(Modal, { ...props.modalProps, className: "c-filter-modal", closeable: closeable, focusOnOpen: false, noPadding: isXSmallResolution, onClose: props.onClose, title: modalTitle },
        React.createElement("div", { className: "c-filter-modal__content" },
            React.createElement(ContextualBar, { theme: props.theme, title: contextualBarTitle, uuid: "fake-uuid" }, props.children))));
}
export { FilterModal, };
//# sourceMappingURL=filter-modal.js.map